import { IconButton, InputAdornment, Stack, Typography } from '@mui/material';
import { PopoverTrigger } from 'src/components/PopoverTrigger';
import { CustomTextField } from 'src/components/custom-input';
import Iconify from 'src/components/iconify';
import { OrderCollaborateNavPopOver } from 'src/layouts/DashboardLayout/shared/OrderCollaborateNavPopOver';
import { useLocales } from 'src/locales';

type Props = {
  searchText: string;
  onChangeSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleOrderSelect: (orderType: 'asc' | 'desc') => void;
  orderBy: 'asc' | 'desc';
};

export const DocsTrashHeader = ({
  handleOrderSelect,
  orderBy,
  searchText,
  onChangeSearch,
}: Props) => {
  const { translate } = useLocales();

  return (
    <Stack p={1} gap={1}>
      <Typography variant="button">
        {translate('collaborate.docs.trash.title')}
      </Typography>

      <Stack direction="row" gap={1} alignItems="center">
        <CustomTextField
          size="small"
          fullWidth
          value={searchText}
          onChange={onChangeSearch}
          placeholder={translate('header.nav.search_for_a_doc')}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" />
              </InputAdornment>
            ),
          }}
        />

        <PopoverTrigger
          popover={OrderCollaborateNavPopOver}
          context={{
            handleOrderSelect,
            orderBy,
          }}
        >
          <IconButton size="small">
            <Iconify icon="tabler:arrows-sort" />
          </IconButton>
        </PopoverTrigger>
      </Stack>
    </Stack>
  );
};
